export function faq() {
    const isMobile = $(window).width() < 768;
    let $faq = $(".question-box");
    let $faqSectionLink = $(".faq .faq-holder .categories li a");
    let $activeCategoryMobileTitle = $(".active-category-mobile-title");
    let $questionsHolder = $(".questions-holder");
    $faq.find(".title-wrapper").on("click", function () {
        let $this = $(this);
        if ($this.parent().hasClass("active")) {
            $this.parent().removeClass("active");
            $this.next(".answer").slideUp(350);
        } else {
            $faq.removeClass(".active").next(".answer").slideUp(350);
            $this.parent().addClass("active");
            $this.next(".answer").slideDown(350);
        }
        return false;
    });

    $faqSectionLink.on("click", function () {
        let target = $($(this).data("target"));
        let title = $(this).text();
        $faqSectionLink.removeClass("active");
        $(this).addClass("active");
        $(".question-box").removeClass("visible").addClass("d-none");
        target.each(function () {
            $(this).parent().prepend($(this));
            $(this).removeClass("d-none").addClass("visible");
        });
        if (isMobile) {
            $activeCategoryMobileTitle.find("span").text(title);
            $activeCategoryMobileTitle.show();
            $questionsHolder.show();
        }
    });

    $("section.faq .question").click(function () {
        $(this).toggleClass("active");
    });

    const parseSearchResults = (results) => {
        const resultsList = $(".form-results ul");
        resultsList.empty();
        let post;
        for (post = 0; post < results.length; post++) {
            resultsList.append(`
                <li>
                    <a href="#question-${results[post].ID}">${results[post].post_title}</a>
                </li>
            `);
        }
    };

    const scrollToQuestion = (question) => {
        let questionBox = $(question);
        let headerHeight = $(".header").height() + $(".announcement-bar").height();
        $("html, body").animate({
            scrollTop: questionBox.offset().top - headerHeight
        }, 500);
        questionBox.find(".title-wrapper").trigger("click");
        if (isMobile) {
            $activeCategoryMobileTitle.find("span").text("Search");
            $activeCategoryMobileTitle.show();
            $questionsHolder.show();
        }
    };

    const setSearchInputValue = (value) => {
        $(".faq-search-form input").val(value);
        $(".form-results").hide();
    };

    const closeMobilePanel = () => {
        $activeCategoryMobileTitle.hide();
        $questionsHolder.hide();
    };

    $(".faq-search-form input").keyup(function () {
        let value = $(this).val();
        if (value.length > 3) {
            $(".question-box").removeClass("d-none").addClass("visible");
            $faqSectionLink.removeClass("active");

            $.ajax({
                type: "POST",
                url: window.adminUrl + "?search_term=" + value,
                dataType: "json",
                data: { action: "get_questions" },
                success: function (response) {
                    parseSearchResults(response);
                    $(".form-results").show();
                }
            });
        }
    }).focus(function () {
        $(this).val("");
    });

    $(document).on("click", ".form-results a", function (e) {
        e.preventDefault();
        scrollToQuestion($(this).attr("href"));
        setSearchInputValue($(this).text());
    });

    $(document).on("click", ".active-category-mobile-title a", function (e) {
        closeMobilePanel();
        $faqSectionLink.removeClass("active");
    });

}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/faq.js